import { ConnectedStore } from '../../types/ConnectedStore';

const getStoreInfo = (storeId: string, availableStores: ConnectedStore[]) =>
    availableStores && availableStores.find(x => x.id === storeId);

const getStoresAvailableForUser = (
    availableStores: ConnectedStore[],
    userFilteredStores: string[] | undefined
) => {
    if (!userFilteredStores?.length || userFilteredStores.includes('all')) return availableStores;

    return availableStores.filter(s => userFilteredStores.includes(s.id));
};

export { getStoreInfo, getStoresAvailableForUser };
